export const getUrlParameter = (param) => {
  param = param.replace(/[\\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + param + "=([^&#]*)");
  const results = regex.exec(window.location.search);

  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export const showCookiePreference = (e) => {
  e.preventDefault();
  window?.Osano?.cm?.showDrawer('osano-cm-dom-info-dialog-open');
};

export const createTValue = (params) => {
  // Check if there are no parameters and return 'organic'
  if (!params.toString()) return "organic";

  // Check for utm parameters
  const taxonomyKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
  ];
  const hasUtmParams = taxonomyKeys.some((key) => params.has(key));

  // If utm parameters are present, map them to a formatted string
  if (hasUtmParams) {
    return taxonomyKeys
      .map((key) => params.get(key) || "")
      .join("_")
      .replace(/\|+$/, "");
  }

  // If no utm parameters, check for specific other parameters
  if (params.has("fbclid")) return "social";
  if (params.has("gclid")) return "cpc";
  if (params.has("dclid") || params.has("_hsenc")) return "display";

  return "organic";
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export const isBrowser = typeof window !== "undefined";

export const isProd = () => {
  if (typeof window !== "undefined") {
    return window.location.hostname.includes('sofdra.com')
  }
  return false
}

export const scrollToSection = (selector) => {
  if (typeof window !== "undefined") {
    const el = document.querySelector(selector);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
};

// Helper function to extract text from React elements
export const getTextFromElement = (element) => {
  if (typeof element === 'string') return element;
  if (Array.isArray(element.props.children)) {
    return element.props.children
      .map(child => getTextFromElement(child))
      .join('');
  }
  return element.props.children || '';
};